<template>
  <div class="standings">
    <div class="bg-white text-default">
      <template v-for="rating in ['drivers', 'junior', 'xp']">
        <div v-if="event && rating in event && event[rating].length" :key="'rating-loop-' + rating" class="padding--bottom-2">
          <h2>{{ $t('results.' + rating) }}</h2>
          <div class="overflow--auto position-relative">
            <table width="100%" class="timing-results d-md-none">
              <tbody>
              <template v-for="(row, rowIndex) in event[rating]">
                <tr :key="rating + '-row-' + event.wigeEventId + '-' + rowIndex">
                  <td rowspan="2" class="font-weight--bold text-align--center td-position"
                      :class="{ 'bg-primary': row.position === '1', 'bg-medium': row.position === '2' || row.position === '3', 'bg-light': parseInt(row.position) > 3 }">{{ ('0' + row.position).slice(-2) }}</td>
                  <td class="padding-off padding-right-off" width="60"><img
                    :src="drivers[event.year + '-' + row.number] && drivers[event.year + '-' + row.number].image ? `https://media.graphcms.com/resize=w:120,fit:crop/quality=value:70/compress/${drivers[event.year + '-' + row.number].image.handle}` : pixel"
                    width="60"
                    :alt="row.name"
                  ></td>
                  <td class="text-align--center padding-right-off">
                    <img :src="(drivers[event.year + '-' + row.number] && drivers[event.year + '-' + row.number].country && drivers[event.year + '-' + row.number].country.appCountryFlag ? drivers[event.year + '-' + row.number].country.appCountryFlag.url : pixel)"
                         width="16" height="16"
                         :title="(drivers[event.year + '-' + row.number] && drivers[event.year + '-' + row.number].country ? drivers[event.year + '-' + row.number].country.name : '')"
                         :alt="(drivers[event.year + '-' + row.number] && drivers[event.year + '-' + row.number].country ? drivers[event.year + '-' + row.number].country.name : '')">
                  </td>
                  <td colspan="2" class="padding-right text-uppercase" v-html="(typeof drivers[event.year + '-' + row.number] !== 'undefined' ? drivers[event.year + '-' + row.number].firstName + ' <b>' + drivers[event.year + '-' + row.number].lastName + '</b><br/><span class=\'font-small\'>' + (drivers[event.year + '-' + row.number] && 'team' in drivers[event.year + '-' + row.number] ? drivers[event.year + '-' + row.number].team.name : '') + '</span>' : row.firstName + ' <b>' + row.lastName + '</b>')"></td>
                </tr>
                <tr :key="rating + '-row-' + event.wigeEventId + '--' + row.id">
                  <td class="text-align--left no-border" colspan="2">
                    <b>{{ $t('results.points') }}</b><br/>
                    <b v-html="row.totalpoints"></b>
                  </td>
                  <td class="text-align--left no-border">
                    {{ $t('results.race') }}<br/>
                    {{ row.racepoints }}
                  </td>
                  <td class="text-align--right no-border" width="80">
                    {{ $t('results.qualifying') }}<br/>
                    {{ row.qualifyingpoints }}
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
            <table width="100%" class="timing-results d-none d-md-table">
              <thead>
              <tr>
                <th class="text-condensed d-none d-lg-table-cell" width="60">{{ $t('results.position') }}</th>
                <th class="text-condensed d-lg-none" width="60">#</th>
                <th class="text-condensed pa">&nbsp;</th>
                <th class="text-condensed tl">{{ $t('results.driver') }} / {{ $t('results.team') }}</th>
                <th class="text-condensed">&nbsp;</th>
                <th class="text-condensed">{{ $t('results.points') }}</th>
                <th class="text-condensed">{{ $t('results.race') }}</th>
                <th class="text-condensed">{{ $t('results.qualifying') }}</th>
                <template v-for="(race, raceIndex) in event.races">
                  <th :title="race.name"
                      :key="rating + '-raceindex-' + raceIndex"
                      :class="{ 'padding-left-off': raceIndex > 0 }"
                      class="text-condensed d-none d-lg-table-cell">
                    Q{{ (raceIndex + 1) }}<br/>
                    R{{ (raceIndex + 1) }}
                  </th>
                </template>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(row, driversIndex) in event[rating]" :key="rating + '-' + driversIndex">
                <td class="sticky font-weight--bold text-align--center td-position"
                    :class="{ 'bg-primary': row.position === '1', 'bg-medium': row.position === '2' || row.position === '3', 'bg-light': parseInt(row.position) > 3 }">{{ ('0' + row.position).slice(-2) }}</td>
                <td class="text-align--center">
                  <img :src="(drivers[event.year + '-' + row.number] && drivers[event.year + '-' + row.number].country && drivers[event.year + '-' + row.number].country.appCountryFlag ? drivers[event.year + '-' + row.number].country.appCountryFlag.url : pixel)"
                       width="16" height="16"
                       :title="(drivers[event.year + '-' + row.number] && drivers[event.year + '-' + row.number].country ? drivers[event.year + '-' + row.number].country.name : '')"
                       :alt="(drivers[event.year + '-' + row.number] && drivers[event.year + '-' + row.number].country ? drivers[event.year + '-' + row.number].country.name : '')">
                </td>
                <!-- TODO add additional ranking field here -->
                <td class="sticky padding-right text-uppercase padding-left-off"
                    v-html="(typeof drivers[event.year + '-' + row.number] !== 'undefined' ? drivers[event.year + '-' + row.number].firstName + ' <b>' + drivers[event.year + '-' + row.number].lastName + '</b><br/><span class=\'font-small\'>' + (drivers[event.year + '-' + row.number] && 'team' in drivers[event.year + '-' + row.number] ? drivers[event.year + '-' + row.number].team.name : '') + '</span>' : row.firstName + ' <b>' + row.lastName + '</b>')"></td>
                <td class="text-condensed">
                  <img
                    :src="drivers[event.year + '-' + row.number] && drivers[event.year + '-' + row.number].team && drivers[event.year + '-' + row.number].team.manufacturer && drivers[event.year + '-' + row.number].team.manufacturer.image ? drivers[event.year + '-' + row.number].team.manufacturer.image.url : pixel"
                    alt=""
                    class="imageLight"
                    width="60">
                  <img
                    :src="drivers[event.year + '-' + row.number] && drivers[event.year + '-' + row.number].team && drivers[event.year + '-' + row.number].team.manufacturer && drivers[event.year + '-' + row.number].team.manufacturer.imageDark ? drivers[event.year + '-' + row.number].team.manufacturer.imageDark.url : pixel"
                    alt=""
                    class="imageDark"
                    width="60">
                </td>
                <td class="text-align--center"><b v-html="row.totalpoints"></b></td>
                <td class="text-align--center" v-html="row.racepoints"></td>
                <td class="text-align--center" v-html="row.qualifyingpoints"></td>
                <template v-for="(race, raceIndex) in row.races">
                  <td :title="race.name"
                      :key="rating + '-raceindex-' + raceIndex + '-driver-' + driversIndex"
                      :class="{ 'padding-left-off': raceIndex > 0 }"
                      class="text-condensed text-align--center d-none d-lg-table-cell font-small">
                    <div :class="{ 'opacity--50': race.qualifyingpoints === '0' }" v-html="race.qualifyingpoints"></div>
                    <div :class="{ 'opacity--50': race.racepoints === '0' }" v-html="race.racepoints"></div>
                  </td>
                </template>
                <template v-for="(race, raceIndex) in event.races">
                  <td
                    :key="rating + '-raceindex-empty-' + raceIndex + '-driver-' + driversIndex"
                    v-if="raceIndex > row.races.length - 1"
                    class="text-condensed text-align--center font-small d-none d-lg-table-cell">&nbsp;</td>
                </template>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
      <div v-if="event && 'teams' in event && event.teams.length">
        <h2>{{ $t('results.team') }}</h2>
        <div class="overflow--auto position-relative">
          <table width="100%" class="timing-results">
            <thead>
            <tr>
              <th class="text-condensed d-none d-lg-table-cell" width="60">{{ $t('results.position') }}</th>
              <th class="text-condensed d-lg-none" width="60">POS</th>
              <th class="text-condensed tl">{{ $t('results.team') }}</th>
              <th class="text-condensed d-none d-md-table-cell">&nbsp;</th>
              <th width="80" class="text-condensed">{{ $t('results.points') }}</th>
              <template v-for="(race, raceIndex) in event.races">
                <th :title="race.name"
                    :key="'raceindex-' + raceIndex"
                    :class="{ 'padding-left-off': raceIndex > 0 }"
                    class="text-condensed d-none d-lg-table-cell">
                  R{{ (raceIndex + 1) }}
                </th>
              </template>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, teamsIndex) in event.teams" :key="'teams-' + teamsIndex">
              <td class="sticky font-weight--bold text-align--center td-position"
                  :class="{ 'bg-primary': row.position === '1', 'bg-medium': row.position === '2' || row.position === '3', 'bg-light': parseInt(row.position) > 3 }">{{ ('0' + row.position).slice(-2) }}</td>
              <td class="sticky padding-right text-uppercase" v-html="row.name"></td>
              <td class="d-none d-md-table-cell">
                <img
                  :src="teams[row.name.toUpperCase()] && teams[row.name.toUpperCase()].manufacturer && teams[row.name.toUpperCase()].manufacturer.image ? teams[row.name.toUpperCase()].manufacturer.image.url : pixel"
                  alt=""
                  class="imageLight"
                  width="60">
                <img
                  :src="teams[row.name.toUpperCase()] && teams[row.name.toUpperCase()].manufacturer && teams[row.name.toUpperCase()].manufacturer.imageDark ? teams[row.name.toUpperCase()].manufacturer.imageDark.url : pixel"
                  alt=""
                  class="imageDark"
                  width="60">
              </td>
              <td class="text-align--center"><b v-html="row.totalpoints"></b></td>
              <template v-for="(race, raceIndex) in row.races">
                <td :title="race.name"
                    :key="'raceindex-' + raceIndex + '-teams-' + teamsIndex"
                    :class="{ 'padding-left-off': raceIndex > 0 }"
                    class="text-condensed text-align--center font-small d-none d-lg-table-cell">
                  <div :class="{ 'opacity--50': race.points === '0' }" v-html="race.points"></div>
                </td>
              </template>
              <template v-for="(race, raceIndex) in event.races">
                <td
                  :key="'raceindex-empty-' + raceIndex + '-teams-' + teamsIndex"
                  v-if="raceIndex > row.races.length - 1"
                  class="text-condensed text-align--center font-small d-none d-lg-table-cell">&nbsp;</td>
              </template>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="padding--bottom-2"></div>
      <div v-if="event && 'manufacturers' in event && event.manufacturers.length">
        <h2>{{ $t('results.manufacturer') }}</h2>
        <div class="overflow--auto position-relative">
          <table width="100%" class="timing-results">
            <thead>
            <tr>
              <th class="text-condensed d-none d-lg-table-cell" width="60">{{ $t('results.position') }}</th>
              <th class="text-condensed d-lg-none" width="60">POS</th>
              <th class="text-condensed tl">{{ $t('results.manufacturer') }}</th>
              <th class="text-condensed" width="80">{{ $t('results.points') }}</th>
              <template v-for="(race, raceIndex) in event.races">
                <th :title="race.name"
                    :key="'raceindex-' + raceIndex"
                    :class="{ 'padding-left-off': raceIndex > 0 }"
                    class="text-condensed text-condensed d-none d-lg-table-cell">
                  R{{ (raceIndex + 1) }}
                </th>
              </template>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, manufacturersIndex) in event.manufacturers" :key="'manufacturers-' + manufacturersIndex">
              <td class="sticky font-weight--bold text-align--center td-position"
                  :class="{ 'bg-primary': row.position === '1', 'bg-medium': row.position === '2' || row.position === '3', 'bg-light': parseInt(row.position) > 3 }">{{ ('0' + row.position).slice(-2) }}</td>
              <td class="sticky padding-right text-uppercase" v-html="row.name"></td>
              <td class="text-align--center"><b v-html="row.totalpoints"></b></td>
              <template v-for="(race, raceIndex) in row.races">
                <td :title="race.name"
                    :key="'raceindex-' + raceIndex + '-manufacturer-' + manufacturersIndex"
                    :class="{ 'padding-left-off': raceIndex > 0 }"
                    class="text-condensed text-align--center font-small d-none d-lg-table-cell">
                  <div :class="{ 'opacity--50': race.points === '0' }" v-html="race.points"></div>
                </td>
              </template>
              <template v-for="(race, raceIndex) in event.races">
                <td
                  :key="'raceindex-empty-' + raceIndex + '-manufacturer-' + manufacturersIndex"
                  v-if="raceIndex > row.races.length - 1"
                  class="text-condensed text-align--center font-small d-none d-lg-table-cell">&nbsp;</td>
              </template>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="padding--bottom-2"></div>
    </div>
  </div>
</template>

<script>
import AppConst from '../config/app.const';
import Settings from '../config/settings';

export default {
  name: 'Standings',
  props: {
    baseEvent: Object,
    raceSeries: String,
    settings: Object,
    headline: String
  },
  data () {
    return {
      loading: true,
      event: {},
      drivers: {},
      teams: {},
      headlineVisible: false,
      page: {},
      pixel: AppConst.PIXEL
    };
  },
  computed: {
    queryName: function () {
      return this.$store.getters['page/raceSeriesDrivers'];
    }
  },
  methods: {
    async fetchDrivers () {
      await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
        path: `data?query=${this.queryName}`,
        lifetime: Settings.LIFETIME_DEFAULT
      }).then(response => {
        const teams = {};
        const drivers = {};
        response.drivers.forEach((driver) => {
          let age = 0;
          if (driver.appBirth) {
            const split = driver.appBirth.split('.');
            const birthDay = new Date(split[2], split[1] - 1, split[0]);
            const ageDifMs = Date.now() - birthDay.getTime();
            const ageDate = new Date(ageDifMs); // miliseconds from epoch
            age = Math.abs(ageDate.getUTCFullYear() - 1970);
          }
          driver.age = age;
          const year = driver.driverUniqueID.substr(-4);
          if ('teamTrophies' in driver && driver.teamTrophies.length) {
            driver.team = {
              manufacturer: driver.teamTrophies[0].manufacturerTrophy,
              name: driver.teamTrophies[0].name
            };
          }
          if (driver.team) {
            teams[driver.team.name.toUpperCase()] = driver.team;
          }
          drivers[year + '-' + driver.driverNumber] = driver;
        });
        this.drivers = drivers;
        this.teams = teams;
      });
    },
    async fetchStandings () {
      const now = new Date();
      let startDate = new Date(now.getFullYear() + '-01-01');
      let endDate = new Date(now.getFullYear() + '-12-31');
      let raceSeries = 'DTM';
      if (this.raceSeries) {
        raceSeries = this.raceSeries.toUpperCase();
      }
      if (this.baseEvent) {
        const startTime = new Date(this.baseEvent.startTime);
        const endTime = new Date(this.baseEvent.endTime);
        startDate = new Date(startTime.getFullYear() + '-' + (startTime.getMonth() + 1) + '-' + startTime.getDate());
        endDate = new Date(endTime.getFullYear() + '-' + (endTime.getMonth() + 1) + '-' + endTime.getDate());
      }
      if (this.settings && 'startDate' in this.settings && 'endDate' in this.settings) {
        startDate = new Date(this.settings.startDate);
        endDate = new Date(this.settings.endDate);
      }
      if (this.settings && 'raceSeries' in this.settings) {
        raceSeries = this.settings.raceSeries.toUpperCase();
      }
      const schema = raceSeries === 'DTM' ? 'wigeStandings' : 'wigeStandingsTrophy';
      await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
        path: 'data?query=' +
          schema +
          '&raceSeries=' +
          raceSeries +
          '&startDate=' +
          (startDate.getFullYear() + '-' + ('00' + (startDate.getMonth() + 1)).slice(-2) + '-' + ('00' + startDate.getDate()).slice(-2)) +
          '&endDate=' +
          (endDate.getFullYear() + '-' + ('00' + (endDate.getMonth() + 1)).slice(-2) + '-' + ('00' + endDate.getDate()).slice(-2)),
        lifetime: Settings.LIFETIME_DEFAULT
      })
        .then(response => {
          const resultName = raceSeries === 'DTM' ? 'wigeStandingses' : 'wigeStandingsTrophies';
          if (resultName in response) {
            const event = {};
            response[resultName].forEach((row) => {
              if (!('wigeEventId' in event)) {
                const date = new Date(row.startDate);
                event.jsonData = JSON.parse(row.jsonText);
                event.wigeEventId = row.wigeEventId;
                event.startDate = row.startDate;
                event.endDate = row.endDate;
                event.races = event.jsonData.pointsessions;

                // point types
                event.drivers = [];
                event.manufacturers = [];
                event.teams = [];

                event.year = date.getFullYear();
              }
              if ('manufacturers' in event.jsonData) {
                event.manufacturers = event.jsonData.manufacturers;
              }
              if ('teams' in event.jsonData) {
                event.teams = event.jsonData.teams;
              }
              if ('drivers' in event.jsonData) {
                event.drivers = event.jsonData.drivers;
                event.drivers.forEach((driver) => {
                  if (driver) {
                    driver.racepoints = 0;
                    driver.qualifyingpoints = 0;
                    const name = this.formatName(driver.name);
                    driver.firstName = name.firstName;
                    driver.lastName = name.lastName;
                    if ('races' in driver) {
                      driver.races.forEach((race) => {
                        driver.racepoints += parseFloat(race.racepoints);
                        driver.qualifyingpoints += parseFloat(race.qualifyingpoints);
                      });
                    }
                  }
                });
              }
              if ('Junior' in event.jsonData) {
                event.junior = event.jsonData.Junior;
                event.junior.forEach((driver) => {
                  if (driver) {
                    driver.racepoints = 0;
                    driver.qualifyingpoints = 0;
                    const name = this.formatName(driver.name);
                    driver.firstName = name.firstName;
                    driver.lastName = name.lastName;
                    if ('races' in driver) {
                      driver.races.forEach((race) => {
                        driver.racepoints += parseFloat(race.racepoints);
                        driver.qualifyingpoints += parseFloat(race.qualifyingpoints);
                      });
                    }
                  }
                });
              }
              if ('XP' in event.jsonData) {
                event.xp = event.jsonData.XP;
                event.xp.forEach((driver) => {
                  if (driver) {
                    driver.racepoints = 0;
                    driver.qualifyingpoints = 0;
                    const name = this.formatName(driver.name);
                    driver.firstName = name.firstName;
                    driver.lastName = name.lastName;
                    if ('races' in driver) {
                      driver.races.forEach((race) => {
                        driver.racepoints += parseFloat(race.racepoints);
                        driver.qualifyingpoints += parseFloat(race.qualifyingpoints);
                      });
                    }
                  }
                });
              }
            });
            this.event = event;
          }
          this.loading = false;
        })
        .catch(() => {
          //
        });
    },
    formatName: (name) => {
      const fullName = name.split(' ');
      let firstName = '';
      let lastName = name;
      if (fullName.length) {
        firstName = fullName[fullName.length - 1];
        // extra for Jan Philipp, Jose Maria
        if (name.indexOf('Jan Philipp') > -1 || name.indexOf('Jose Maria') > -1) {
          firstName = fullName[fullName.length - 2] + ' ' + fullName[fullName.length - 1];
        }
        lastName = name.substr(0, name.length - firstName.length).trim();
      }
      return { firstName: firstName, lastName: lastName };
    }
  },
  created () {
    this.fetchDrivers();
    this.fetchStandings();
  },
  watch: {
    settings: function (newVal, oldVal) {
      this.fetchStandings();
    }
  }
};
</script>

<style lang="scss">
  .standings {
    &__fold {
      $fold: &;
      position: relative;
      background: $color-bg;
      color: #fff;
      padding: $gap;
      font-weight: 600;
      text-transform: uppercase;
      transition: all .3s;
      font-size: 1.2em;
      cursor: pointer;
      &__icon {
        position: absolute;
        right: $gap;
        transform: rotate(-90deg);
        transition: all .4s $ease-out-back;
      }
      &:hover {
        background: $color-bg-light;
        #{$fold}__icon {
          transform: rotate(-270deg);
        }
      }
      &.view {
        #{$fold}__icon {
          transform: rotate(-270deg);
        }
      }
    }
    &__content {
      position: relative;
      overflow: hidden;
      max-height: 0;
      transition: all 1s $ease-out-cubic;
      &.view {
        transition: all 1s $ease-in-cubic;
        max-height: 5000px;
      }
    }
    &__select {
      &__icon {
        transform: rotate(270deg);
        position: absolute;
        top: 8px;
        right: 6px;
        color: #fff;
        z-index: 0;
      }
      select {
        cursor: pointer;
        position: relative;
        -moz-appearance: none;
        -webkit-appearance: none;
        appearance: none;
        border: 1px solid $color-bg;
        padding: 10px $gap * 5 10px $gap;
        max-width: 100%;
        background: transparent;
        z-index: 1;
        color: $color-bg;
        text-transform: uppercase;
        &::-ms-expand {
          display: none;
        }
        &:focus {
          outline: none;
        }
        option {
          color: $color-bg;
        }
      }
    }
  }
</style>
